import { AutocompleteIcon } from './customIcons';

import type { OverWritable } from '../../@types/settings';

export const autocomplete: OverWritable = {
  MuiAutocomplete: {
    defaultProps: {
      popupIcon: <AutocompleteIcon />,
    },

    styleOverrides: {
      paper: ({ theme }) => ({
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        boxShadow: theme.customShadows.z24,
        borderRadius: Number(theme.shape.borderRadius) * 2,
      }),
      option: ({ theme }) => ({
        ...theme.typography.body2,
        borderRadius: theme.shape.borderRadius,
      }),
    },
  },
};
